export default __webpack_public_path__ + "static/chair-82aa331e9644164809130b1e84f92e70.svg";